export default __webpack_public_path__ + "static/media/landing-background.81e7d702.png";